import { dispatch } from '../index'
import {
    REGISTRATION_SET_TOKEN,
    REGISTRATION_SET_DATA,
    REGISTRATION_SET_LOADING,
    REGISTRATION_SET_USER_ATTRIBUTES,
    REGISTRATION_SET_ERROR_MESSAGE,
    REGISTRATION_SHOW_CONFIRMATION_FORM,
    AUTH_SHOW_RESET_PASSWORD,
    LOGIN_SHOW_NEW_PASSWORD,
    AUTH_SHOW_LOGIN,
    AUTH_SET_PASSWORD_RESET_TOKEN,
    AUTH_SET_USER,
    REGISTRATION_SET_SHOW_POP_UP,
    REGISTRATION_SET_SHOW_HELP,
    REGISTRATION_SET_CREATE_OCCUPANCY,
    REGISTRATION_SET_SHOW_NOTIFICATION
} from '../actionTypes'

// Login
export const setShowNewPassword = (show) => dispatch({ show, type: LOGIN_SHOW_NEW_PASSWORD })

// General
export const setShowLogin = (show) => dispatch({ show, type: AUTH_SHOW_LOGIN })
export const setShowResetPassword = (show) => dispatch({ show, type: AUTH_SHOW_RESET_PASSWORD })
export const setPasswordResetToken = (token) => dispatch({ token, type: AUTH_SET_PASSWORD_RESET_TOKEN })
export const setUser = (user) => dispatch({ user, type: AUTH_SET_USER })

// Registration
export const setToken = (e) => dispatch({ value: e, type: REGISTRATION_SET_TOKEN })
export const setData = (data) => dispatch({ data: data, type: REGISTRATION_SET_DATA })
export const setLoading = (loading) => dispatch({ loading, type: REGISTRATION_SET_LOADING })
export const setUserAttributes = (attributes) => dispatch({ attributes, type: REGISTRATION_SET_USER_ATTRIBUTES })
export const setErrorMessage = (message) => dispatch({ message, type: REGISTRATION_SET_ERROR_MESSAGE })
export const showConfirmationForm = (username, code, resend) => dispatch({ username, code, resend, type: REGISTRATION_SHOW_CONFIRMATION_FORM })
export const setShowPopUp = (value) => dispatch({showPopUp: value, type: REGISTRATION_SET_SHOW_POP_UP})

export const setShowHelp = (value) => dispatch({show: value, type: REGISTRATION_SET_SHOW_HELP})
export const setShowNotifications = (value) => dispatch({show: value, type: REGISTRATION_SET_SHOW_NOTIFICATION})
export const setCreateNewOccupancy = (value) => dispatch({value: value, type: REGISTRATION_SET_CREATE_OCCUPANCY})